// eslint-disable-next-line global-require
export const importImage = imagePath => { // eslint-disable-line import/no-dynamic-require, import/prefer-default-export
  const path = new URL(`../../img/${imagePath}`, import.meta.url);
  return path;
};
